<template>
  <CHeader with-subheader>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand
      class="mx-lg-auto d-lg-none"
      src="~/img/brand/logo_skl.svg"
      width="97"
      height="46"
      alt="CoreUI Logo"
    />
    <div class="d-none d-md-block d-lg-block d-xl-block">
      <CBreadcrumbRouter class="my-1 border-0" />
    </div>
    <CHeaderNav class="d-md-down-none mr-auto"> </CHeaderNav>
    <CHeaderNav class="ml-auto mr-2">
      <CHeaderNavItem class="mx-2" v-if="$store.getters.getShowDropdownBrand">
        <b-dropdown
          id="dropdown-1"
          class="my-md-2 btn-brand-selected small-dropdown"
          right
          no-flip
        >
          <template v-slot:button-content>
            <div class="d-flex">
              <div class="mr-2">
                <b-avatar
                  v-if="getBrandDetail()"
                  variant=""
                  :src="getBrandDetail().logo"
                  size="1.5rem"
                  class="my-auto"
                ></b-avatar>
              </div>

              <div class="my-auto" v-if="getBrandDetail()">
                {{ getBrandDetail().name }}
              </div>
            </div>
          </template>
          <template v-for="brand in getBrandList()">
            <b-dropdown-item
              :key="brand.brandID"
              @click="clickChangeBrand(brand)"
            >
              <div class="d-flex">
                <div class="mr-2">
                  <b-avatar
                    variant=""
                    :src="brand.logo"
                    size="1.5rem"
                    class="my-auto"
                  ></b-avatar>
                </div>

                <div class="my-auto">
                  {{ brand.name }}
                </div>
              </div>
            </b-dropdown-item>
          </template>
        </b-dropdown>
      </CHeaderNavItem>
      <!-- <CHeaderNavItem
        class="mx-2 d-none d-md-block d-lg-block d-xl-block"
        v-if="getUserDetail()"
      >
       
      </CHeaderNavItem> -->

      <TheHeaderDropdownAccnt />
    </CHeaderNav>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";
import { mapGetters } from "vuex";

export default {
  name: "TheHeader",
  data() {
    return {
      displayName: "",
      name: "",
      modalMessage: "Are you sure you want to log out ?",
    };
  },
  created: async function () {
    if (this.$route.name != "welcome") {
      setTimeout(() => {
        this.handleActiveMenuChild(this.$route.meta);
      }, 1000);
    }
  },
  computed: {
    ...mapGetters([
      "getBrandDetail",
      "getBrandList",
      "getCurrentBrandID",
      "getUserDetail",
    ]),
  },
  watch: {
    "$route.meta"(newValue, oldValue) {
      this.handleActiveMenu(newValue, oldValue);
    },
  },
  methods: {
    clickChangeBrand(brand) {
      window.location.href = `/order?brandID=${brand.id}`;
    },
    handleActiveMenu: async function (newValue, oldValue) {
      if (newValue.activeUrl != oldValue.activeUrl) {
        await this.handleRemoveActiveMenuChild(oldValue);
      }
      await this.handleActiveMenuChild(newValue);
    },
    handleActiveMenuChild: async function (meta) {
      // .ps__rail-y
      var ele = await this.getAllElementsWithAttribute(
        "a",
        "href",
        `${meta.activeUrl}`
      );
      var parentElement = ele.parentElement.parentElement.parentElement;

      if (parentElement && parentElement.className == "c-sidebar-nav-dropdown")
        parentElement.setAttribute("class", "c-sidebar-nav-dropdown c-show");

      if (meta.lv == 1 && ele.className == "c-sidebar-nav-dropdown")
        ele.setAttribute("class", "c-sidebar-nav-dropdown c-show");
      else if (
        meta.lv == 3 &&
        parentElement.parentElement.parentElement.className ==
          "c-sidebar-nav-dropdown"
      )
        parentElement.parentElement.parentElement.setAttribute(
          "class",
          "c-sidebar-nav-dropdown c-show"
        );

      if (meta.isChildren && ele.className == "c-sidebar-nav-link")
        await ele.setAttribute(
          "class",
          "router-link-exact-active c-active c-sidebar-nav-link"
        );

      setTimeout(() => {
        var div = document.getElementsByClassName("ps__rail-y")[0];
        div.style.top = `${ele.getBoundingClientRect().top}px`;
        ele.focus();
      }, 500);
      this.routeMeta = meta;
    },
    handleRemoveActiveMenuChild: async function (oldMeta) {
      if (oldMeta.activeUrl != "/welcome") {
        var oldEle = this.getAllElementsWithAttribute(
          "a",
          "href",
          oldMeta.activeUrl
        );
        var parentElement = oldEle.parentElement.parentElement.parentElement;

        if (
          parentElement &&
          parentElement.className == "c-sidebar-nav-dropdown c-show"
        )
          parentElement.setAttribute("class", "c-sidebar-nav-dropdown");

        if (
          oldMeta.lv == 1 &&
          oldEle.className == "c-sidebar-nav-dropdown c-show"
        )
          oldEle.setAttribute("class", "c-sidebar-nav-dropdown");
        else if (
          oldMeta.lv == 3 &&
          parentElement.parentElement.parentElement.className ==
            "c-sidebar-nav-dropdown c-show"
        )
          parentElement.parentElement.parentElement.setAttribute(
            "class",
            "c-sidebar-nav-dropdown"
          );

        if (
          oldMeta.isChildren &&
          oldEle.className ==
            "router-link-exact-active c-active c-sidebar-nav-link"
        )
          await oldEle.setAttribute("class", "c-sidebar-nav-link");
      }
    },
    getAllElementsWithAttribute(tagName, attribute, val) {
      var allElements = Array.from(document.getElementsByTagName(tagName));
      var filtered = allElements.filter((ele) => {
        return (
          ele.getAttribute(attribute) !== null &&
          ele.getAttribute(attribute) == val
        );
      });

      if (filtered.length) return filtered[0];
      else return false;
    },
  },
  components: {
    TheHeaderDropdownAccnt,
  },
};
</script>

<style scoped>
::v-deep .lang-dd button {
  background-color: transparent;
  border: none;
  padding: 0;
}

::v-deep .lang-dd button:focus,
::v-deep .lang-dd button:active,
::v-deep .lang-dd.show > .btn-secondary.dropdown-toggle,
::v-deep .lang-dd button:hover {
  background-color: transparent !important;
  border: none;
  padding: 0;
}

.lang-dd {
  border: 1px solid #dcdcdc;
  padding: 5px 10px;
}

::v-deep .lang-dd ul {
  width: 100px;
}

.modal-header {
  border-bottom: 0 !important;
  margin: 0px;
  padding: 0px;
  padding-bottom: 0.25rem;
}

.text-msg {
  font-size: 2rem;
  color: #4a4a4a;
}

.btn-modal {
  width: 100px;
  font-weight: bold;
}

.text-text {
  color: #4a4a4a;
  margin-bottom: 0;
  font-size: 1.2rem;
}

.img {
  width: 100px;
}
</style>
